"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcResponsiveMenuV2 = void 0;
var common_constants_1 = require("../../../../common/constants/common-constants");
var bc_pop_over_constants_1 = require("../../../atoms/bc-pop-over/bc-pop-over-constants");
var bc_menu_v2_constants_1 = require("../bc-menu-v2-constants");
var bc_menu_v2_items_mobile_1 = require("./bc-menu-v2-items-mobile");
var bc_menu_v2_popover_more_1 = require("./bc-menu-v2-popover-more");
var bc_menu_v2_popover_tablet_1 = require("./bc-menu-v2-popover-tablet");
var bc_menu_v2_responsive_logout_1 = require("./bc-menu-v2-responsive-logout");
var BcResponsiveMenuV2 = (function () {
    function BcResponsiveMenuV2() {
        this.isTablet = common_constants_1.BcCommonConstants.FALSE;
        this.arrayInstancesPopOver = [];
    }
    BcResponsiveMenuV2.prototype.ajustTablet = function (menu, subMenuConfig) {
        var _this = this;
        this.configMenu = subMenuConfig;
        var listItemsMenu = menu.querySelector("#".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_LIST_ITEMS));
        var listItemsMenuArr = listItemsMenu.childNodes;
        this.splitItemsResponsive(listItemsMenuArr);
        var targetA = listItemsMenuArr[listItemsMenuArr.length - common_constants_1.COMMON_CONSTANTS_NUMBERS.N1];
        this.bcMenuV2PopOverTablet = new bc_menu_v2_popover_tablet_1.BcMenuV2PopOverTablet({
            menu: menu, listItemsMenuArr: listItemsMenuArr, subMenuConfig: subMenuConfig, configHeaderTablet: this.configHeaderTablet.bind(this),
            setListennerLinksResponsive: this.setListennerLinksResponsive.bind(this), listennerItemsNotPopOvers: this.listennerItemsNotPopOvers.bind(this),
            arrayInstancesPopOver: this.arrayInstancesPopOver, configClickListener: this.configClickListener.bind(this),
            setAccesibilityAriaFalse: this.setAccesibilityAriaFalse.bind(this)
        });
        this.bcMenuV2PopOverTablet.onDeleteClassPressItems = function () { _this.onDeleteClassPressItems(); };
        this.isTablet = common_constants_1.BcCommonConstants.TRUE;
        var configPopOverMore = this.createConfigPopOverMore(targetA, listItemsMenu, listItemsMenuArr, subMenuConfig);
        if (this.shouldConfigurePopOverMore(listItemsMenuArr, subMenuConfig)) {
            this.configurePopOverMoreTablet(targetA, configPopOverMore, subMenuConfig);
            return;
        }
        this._configurePopOverForTablet(listItemsMenuArr, targetA, configPopOverMore, subMenuConfig);
    };
    BcResponsiveMenuV2.prototype.createConfigPopOverMore = function (targetA, listItemsMenu, listItemsMenuArr, subMenuConfig) {
        return {
            popOverMegaMenu: targetA, listItemsMenu: listItemsMenu, setAccesibilityAriaFalse: this.setAccesibilityAriaFalse.bind(this), setAccesibilityAriaTrue: this.setAccesibilityAriaTrue.bind(this),
            arrayInstancesPopOver: this.arrayInstancesPopOver, configClickListener: this.configClickListener.bind(this), closePopOvers: this.closePopOvers.bind(this),
            listItemsMenuArr: listItemsMenuArr, subMenuConfig: subMenuConfig, configHeader: this.configHeader.bind(this), configHeaderTablet: this.configHeaderTablet.bind(this), isTablet: this.isTablet
        };
    };
    BcResponsiveMenuV2.prototype.shouldConfigurePopOverMore = function (listItemsMenuArr, subMenuConfig) {
        var _a;
        return listItemsMenuArr.length <= common_constants_1.COMMON_CONSTANTS_NUMBERS.N5 && ((_a = subMenuConfig === null || subMenuConfig === void 0 ? void 0 : subMenuConfig.logout) === null || _a === void 0 ? void 0 : _a.state) === bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE;
    };
    BcResponsiveMenuV2.prototype.configurePopOverMoreTablet = function (targetA, configPopOverMore, subMenuConfig) {
        var _this = this;
        var _a;
        if (!targetA.getAttribute(common_constants_1.BcCommonConstants.ID)) {
            this.bcMenuV2PopOverMoreTablet = new bc_menu_v2_popover_more_1.BcMenuV2PopOverMore(configPopOverMore);
            this.bcMenuV2PopOverMoreTablet.onDeleteClassPressItems = function () { _this.onDeleteClassPressItems(); };
            this.bcMenuV2PopOverMoreTablet.onDeleteClassActiveItems = function () { _this.onDeleteClassActiveItems(); };
            this.bcMenuV2PopOverMoreTablet.onEventResponsive = function (returnEvent, event) { _this.onEventResponsive(returnEvent, event); };
            if (((_a = subMenuConfig.logout) === null || _a === void 0 ? void 0 : _a.state) === bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE) {
                this.bcMenuV2ResponsiveLogoutTablet = new bc_menu_v2_responsive_logout_1.BcMenuV2ResponsiveLogout(subMenuConfig.logout, common_constants_1.BcCommonConstants.FALSE);
                this.bcMenuV2ResponsiveLogoutTablet.onEventLogout = function (event) { _this.eventLogoutResponsive(event); };
            }
        }
    };
    BcResponsiveMenuV2.prototype._configurePopOverForTablet = function (listItemsMenuArr, targetA, configPopOverMore, subMenuConfig) {
        var _this = this;
        var _a;
        if (listItemsMenuArr.length > common_constants_1.COMMON_CONSTANTS_NUMBERS.N5) {
            if (!targetA.getAttribute(common_constants_1.BcCommonConstants.ID)) {
                this.bcMenuV2PopOverMoreTablet = new bc_menu_v2_popover_more_1.BcMenuV2PopOverMore(configPopOverMore);
                this.bcMenuV2PopOverMoreTablet.onDeleteClassPressItems = function () { _this.onDeleteClassPressItems(); };
                this.bcMenuV2PopOverMoreTablet.onDeleteClassActiveItems = function () { _this.onDeleteClassActiveItems(); };
                this.bcMenuV2PopOverMoreTablet.onEventResponsive = function (returnEvent, event) { _this.onEventResponsive(returnEvent, event); };
            }
            if (((_a = subMenuConfig.logout) === null || _a === void 0 ? void 0 : _a.state) === bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE) {
                this.bcMenuV2ResponsiveLogoutTablet = new bc_menu_v2_responsive_logout_1.BcMenuV2ResponsiveLogout(subMenuConfig.logout, common_constants_1.BcCommonConstants.FALSE);
                this.bcMenuV2ResponsiveLogoutTablet.onEventLogout = function (event) { _this.eventLogoutResponsive(event); };
            }
        }
    };
    BcResponsiveMenuV2.prototype.ajustMobile = function (menu, subMenuConfig) {
        var _this = this;
        this.configMenu = subMenuConfig;
        var listItemsMenu = menu.querySelector("#".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_LIST_ITEMS));
        var listItemsMenuArr = listItemsMenu.childNodes;
        this.splitItemsResponsive(listItemsMenuArr);
        this.bcMenuV2ItemsMobile = new bc_menu_v2_items_mobile_1.BcMenuV2ItemsMobile({
            listItemsMenuArr: listItemsMenuArr,
            subMenuConfig: subMenuConfig,
            setAccesibilityAriaFalse: this.setAccesibilityAriaFalse.bind(this),
            setAccesibilityAriaTrue: this.setAccesibilityAriaTrue.bind(this),
            arrayInstancesPopOver: this.arrayInstancesPopOver,
            configHeader: this.configHeader.bind(this),
            setListennerLinksResponsive: this.setListennerLinksResponsive.bind(this),
            listennerItemsNotPopOvers: this.listennerItemsNotPopOvers.bind(this),
            configClickListener: this.configClickListener.bind(this)
        });
        this.bcMenuV2ItemsMobile.onDeleteClassPressItems = function () { _this.onDeleteClassPressItems(); };
        var lengthItemsMobile = listItemsMenuArr[listItemsMenuArr.length - common_constants_1.COMMON_CONSTANTS_NUMBERS.N1];
        var configPopOverMore = this.createConfigPopOverMore(lengthItemsMobile, listItemsMenu, listItemsMenuArr, subMenuConfig);
        if (this.shouldConfigurePopOverMoreMobile(listItemsMenu, listItemsMenuArr, subMenuConfig, lengthItemsMobile)) {
            return;
        }
        this._configureMobileMenu(listItemsMenuArr, lengthItemsMobile, configPopOverMore, subMenuConfig);
    };
    BcResponsiveMenuV2.prototype.shouldConfigurePopOverMoreMobile = function (listItemsMenu, listItemsMenuArr, subMenuConfig, lengthItemsMobile) {
        var _this = this;
        var _a, _b;
        if (listItemsMenuArr.length <= common_constants_1.COMMON_CONSTANTS_NUMBERS.N5 && ((_a = subMenuConfig.logout) === null || _a === void 0 ? void 0 : _a.state) === bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE) {
            if (!lengthItemsMobile.getAttribute(common_constants_1.BcCommonConstants.ID)) {
                this.bcMenuV2PopOverMoreMobile = new bc_menu_v2_popover_more_1.BcMenuV2PopOverMore(this.createConfigPopOverMore(lengthItemsMobile, listItemsMenu, listItemsMenuArr, subMenuConfig));
                this.bcMenuV2PopOverMoreMobile.onDeleteClassPressItems = function () { _this.onDeleteClassPressItems(); };
                this.bcMenuV2PopOverMoreMobile.onDeleteClassActiveItems = function () { _this.onDeleteClassActiveItems(); };
                this.bcMenuV2PopOverMoreMobile.onEventResponsive = function (returnEvent, event) { _this.onEventResponsive(returnEvent, event); };
                if (((_b = subMenuConfig.logout) === null || _b === void 0 ? void 0 : _b.state) === bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE) {
                    this.bcMenuV2ResponsiveLogoutMobile = new bc_menu_v2_responsive_logout_1.BcMenuV2ResponsiveLogout(subMenuConfig.logout, common_constants_1.BcCommonConstants.TRUE);
                    this.bcMenuV2ResponsiveLogoutMobile.onEventLogout = function (event) { _this.eventLogoutResponsive(event); };
                }
            }
            return true;
        }
        return false;
    };
    BcResponsiveMenuV2.prototype._configureMobileMenu = function (listItemsMenuArr, lengthItemsMobile, configPopOverMore, subMenuConfig) {
        var _this = this;
        var _a;
        if (listItemsMenuArr.length > common_constants_1.COMMON_CONSTANTS_NUMBERS.N5) {
            if (!lengthItemsMobile.getAttribute(common_constants_1.BcCommonConstants.ID)) {
                this.bcMenuV2PopOverMoreMobile = new bc_menu_v2_popover_more_1.BcMenuV2PopOverMore(configPopOverMore);
                this.bcMenuV2PopOverMoreMobile.onDeleteClassPressItems = function () { _this.onDeleteClassPressItems(); };
                this.bcMenuV2PopOverMoreMobile.onDeleteClassActiveItems = function () { _this.onDeleteClassActiveItems(); };
                this.bcMenuV2PopOverMoreMobile.onEventResponsive = function (returnEvent, event) { _this.onEventResponsive(returnEvent, event); };
            }
            if (((_a = subMenuConfig.logout) === null || _a === void 0 ? void 0 : _a.state) === bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE) {
                this.bcMenuV2ResponsiveLogoutMobile = new bc_menu_v2_responsive_logout_1.BcMenuV2ResponsiveLogout(subMenuConfig.logout, common_constants_1.BcCommonConstants.TRUE);
                this.bcMenuV2ResponsiveLogoutMobile.onEventLogout = function (event) { _this.eventLogoutResponsive(event); };
            }
            else {
                var itemTargetPopOverMenuV2 = document.querySelector("#".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER_MENU_V2));
                itemTargetPopOverMenuV2.style.height = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N85;
            }
        }
    };
    BcResponsiveMenuV2.prototype.setAccesibilityAriaTrue = function (configli) {
        configli.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_CURRENT, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
        configli.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_EXPANDED, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
    };
    BcResponsiveMenuV2.prototype.setAccesibilityAriaFalse = function (configli) {
        configli.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_CURRENT, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_FALSE);
        configli.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_EXPANDED, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_FALSE);
    };
    BcResponsiveMenuV2.prototype.configHeader = function (itemHeader, pop, megaMenu) {
        if (itemHeader) {
            megaMenu.classList.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_HEADER);
            pop.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_HEADER);
            pop.style.marginTop = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N60X;
            pop.style.height = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_HEIGHT_HEADER;
            pop.firstChild.style.height = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N100;
        }
    };
    BcResponsiveMenuV2.prototype.configHeaderTablet = function (itemHeader, pop) {
        if (itemHeader) {
            pop.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_HEADER);
            pop.style.maxHeight = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N450X;
        }
    };
    BcResponsiveMenuV2.prototype.splitItemsResponsive = function (listItemsMenuArr) {
        if (listItemsMenuArr.length === common_constants_1.COMMON_CONSTANTS_NUMBERS.N5 && this.configMenu.logout.state !== bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE) {
            return;
        }
        for (var index = common_constants_1.COMMON_CONSTANTS_NUMBERS.N4; index < listItemsMenuArr.length; index++) {
            if (index == listItemsMenuArr.length - common_constants_1.COMMON_CONSTANTS_NUMBERS.N1 && listItemsMenuArr[index].getAttribute(common_constants_1.BcCommonConstants.ID)) {
                listItemsMenuArr[index].style.display = common_constants_1.BcCommonConstants.BLOCK;
                continue;
            }
            listItemsMenuArr[index].style.display = common_constants_1.BcCommonConstants.NONE;
        }
    };
    BcResponsiveMenuV2.prototype.setListennerLinksResponsive = function (megaMenu, elementA) {
        var _this = this;
        var links = Array.from(megaMenu.querySelectorAll(".".concat(common_constants_1.BcCommonConstants.BC_LINK_CLASS)));
        var liElement = elementA.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2));
        links.forEach(function (link) {
            link.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                var returnEvent = _this.getReturnEvent(link);
                _this.onEventResponsive(returnEvent, event);
                _this.closePopOvers();
                _this.onDeleteClassActiveItems();
                _this.onDeleteClassPressItems();
                liElement.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE);
            });
        });
    };
    BcResponsiveMenuV2.prototype.getReturnEvent = function (link) {
        var textLink = link.querySelector('span').innerText;
        var titleGroup = link.closest(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_SUBGROUP)).getAttribute('title');
        var titleItem = link.closest('.bc-mega-menu-v2').querySelector('section > h5').innerHTML;
        return {
            titleGroup: titleGroup,
            titleItem: titleItem,
            textLink: textLink
        };
    };
    BcResponsiveMenuV2.prototype.listennerItemsNotPopOvers = function (selectedItem, event) {
        var titleItem = selectedItem.querySelector('li').getAttribute('title');
        var returnEvent = {
            titleItem: titleItem
        };
        this.onEventResponsive(returnEvent, event);
        this.closePopOvers();
        this.onDeleteClassActiveItems();
        this.onDeleteClassPressItems();
        var liItem = selectedItem.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2));
        liItem.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE);
    };
    BcResponsiveMenuV2.prototype.configClickListener = function (popoverInstance, itemTargetli) {
        var isAnyPopOverActive = this.isAnyPopOverActive();
        var isActiveclass = this.isActiveclass();
        var isLiActive = !!itemTargetli.classList.contains(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE);
        this.activateSubmenuAndOpenPopover(isLiActive, isAnyPopOverActive, itemTargetli, popoverInstance);
        this.activatePressStateAndOpenPopover(isLiActive, isAnyPopOverActive, itemTargetli, popoverInstance);
        this.resetAndActivateSubmenu(isLiActive, isAnyPopOverActive, itemTargetli, popoverInstance);
        this.activateSubmenuIfInactive(isLiActive, isAnyPopOverActive, isActiveclass, itemTargetli, popoverInstance);
        this.activatePressStateIfClassActive(isLiActive, isActiveclass, isAnyPopOverActive, itemTargetli, popoverInstance);
    };
    BcResponsiveMenuV2.prototype.activatePressStateIfClassActive = function (isLiActive, isActiveclass, isAnyPopOverActive, itemTargetli, popoverInstance) {
        if (!isLiActive && isActiveclass && !isAnyPopOverActive) {
            itemTargetli.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_PRESS);
            popoverInstance.openPopOver();
        }
    };
    BcResponsiveMenuV2.prototype.activateSubmenuIfInactive = function (isLiActive, isAnyPopOverActive, isActiveclass, itemTargetli, popoverInstance) {
        if (!isLiActive && !isAnyPopOverActive && !isActiveclass) {
            this.onDeleteClassActiveItems();
            this.onDeleteClassPressItems();
            this.closePopOvers();
            itemTargetli.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE);
            popoverInstance.openPopOver();
        }
    };
    BcResponsiveMenuV2.prototype.resetAndActivateSubmenu = function (isLiActive, isAnyPopOverActive, itemTargetli, popoverInstance) {
        if (isLiActive && isAnyPopOverActive) {
            this.onDeleteClassActiveItems();
            this.onDeleteClassPressItems();
            this.closePopOvers();
            itemTargetli.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE);
            popoverInstance.openPopOver();
        }
    };
    BcResponsiveMenuV2.prototype.activatePressStateAndOpenPopover = function (isLiActive, isAnyPopOverActive, itemTargetli, popoverInstance) {
        if (!isLiActive && isAnyPopOverActive) {
            this.onDeleteClassPressItems();
            this.closePopOvers();
            itemTargetli.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_PRESS);
            popoverInstance.openPopOver();
        }
    };
    BcResponsiveMenuV2.prototype.activateSubmenuAndOpenPopover = function (isLiActive, isAnyPopOverActive, itemTargetli, popoverInstance) {
        if (isLiActive && !isAnyPopOverActive) {
            this.onDeleteClassActiveItems();
            this.closePopOvers();
            itemTargetli.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE);
            popoverInstance.openPopOver();
        }
    };
    BcResponsiveMenuV2.prototype.isActiveclass = function (classActive) {
        if (classActive === void 0) { classActive = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE; }
        var mySelf = this.onGetMySelf();
        var ulItem = mySelf.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_LIST_ITEMS));
        var aItems = ulItem.children;
        var arrayItemsVisibles = [];
        for (var _i = 0, _a = Array.from(aItems); _i < _a.length; _i++) {
            var element = _a[_i];
            var isDisplayNone = element.style.display === 'none';
            if (!isDisplayNone) {
                arrayItemsVisibles.push(element);
            }
        }
        return arrayItemsVisibles.some(function (element) {
            var liElement = element.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2));
            return liElement.classList.contains(classActive);
        });
    };
    BcResponsiveMenuV2.prototype.isAnyPopOverActive = function () {
        var popOversMenu = document.querySelectorAll(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER));
        for (var _i = 0, _a = Array.from(popOversMenu); _i < _a.length; _i++) {
            var element = _a[_i];
            if (element.classList.contains(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_ACTIVE)) {
                return true;
            }
        }
        return false;
    };
    BcResponsiveMenuV2.prototype.closePopOvers = function () {
        this.arrayInstancesPopOver.forEach(function (instancePopOver) {
            instancePopOver.closePopOver();
        });
    };
    return BcResponsiveMenuV2;
}());
exports.BcResponsiveMenuV2 = BcResponsiveMenuV2;
